import _taggedTemplateLiteral from "/home/runner/work/is-eth-congested-website/is-eth-congested-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { forwardRef } from 'react';
import styled from 'styled-components';
import BottomBannerContainer from './components/BottomBanner';
import Column from './components/Column';
import FooterContainer from './components/FooterContainer';
import Item from './components/Item';
import ItemsContainer from './components/ItemsContainer';
import Title from './components/Title';
import TopContainer from './components/TopContainer';
/**
 *
 * API:
 *
 * - [Footer API](https://components-extra.netlify.app/components/footer)
 */

var Footer = function Footer(_a) {
  var bottomBanner = _a.bottomBanner,
      children = _a.children,
      forwardedRef = _a.forwardedRef,
      image = _a.image,
      title = _a.title,
      rest = __rest(_a, ["bottomBanner", "children", "forwardedRef", "image", "title"]);

  return React.createElement(FooterContainer, Object.assign({
    ref: forwardedRef
  }, rest), React.createElement(TopContainer, Object.assign({}, image), title && React.createElement(Title, {
    text: title
  }), children && React.createElement(ItemsContainer, null, children)), bottomBanner && React.createElement(BottomBannerContainer, null, bottomBanner));
};

var FooterExtra = styled(forwardRef(function (props, ref) {
  return React.createElement(Footer, Object.assign({}, props, {
    forwardedRef: ref
  }));
}))(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * Exposed components.
 */

FooterExtra.Column = Column;
FooterExtra.Item = Item;
export default FooterExtra;